/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type FlaggedTransactionPaginatedProperty =
  typeof FlaggedTransactionPaginatedProperty[keyof typeof FlaggedTransactionPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FlaggedTransactionPaginatedProperty = {
  TRANSACTION_ID: 'TRANSACTION_ID',
  REFERENCE: 'REFERENCE',
  IBAN_FROM: 'IBAN_FROM',
  IBAN_TO: 'IBAN_TO',
  VALUE_AMOUNT: 'VALUE_AMOUNT',
  VALUE_CURRENCY: 'VALUE_CURRENCY',
  PAYMENT_DIRECTION: 'PAYMENT_DIRECTION',
  PAYMENT_STATE_TYPE: 'PAYMENT_STATE_TYPE',
  CREATED_AT: 'CREATED_AT',
  OWNER_NAME: 'OWNER_NAME',
} as const;
